import * as types from './mutation-type';

export default {
  [types.SHOW_ALERT]: (state, { type, msg }) => {
    state.alert = Object.assign({}, {
      show: true,
      type,
      msg
    });
  },
  [types.HIDE_ALERT]: (state) => {
    state.alert = Object.assign({}, {
      show: false
    });
  },
  [types.UPDATE_CHANCE]: (state, chance) => {
    state.chance = chance;
  },
  [types.UPDATE_PRIZE]: (state, {list, realinfo}) => {
    state.prizeList = Object.assign({}, {list, realinfo});
  },
  [types.SHOW_MODAL]: (state, { type, prize, win, share, rule, copy, material, overlay }) => {
    state.modal.win = [];
    overlay = overlay || false
    state.modal = Object.assign({}, {
      show: true,
      type,
      prize,
      win,
      share,
      rule,
      copy,
      material,
      overlay
    });
  },
  [types.SHOW_MODAL2]: (state, { type, material, address }) => {
    state.modal2.win = [];
    state.modal2 = Object.assign({}, {
      show: true,
      type,
      material,
      address
    });
  },
  [types.HIDE_MODAL2]: (state) => {
    state.modal2 = Object.assign(state.modal2, {
      show: false
    });
  },
  [types.HIDE_MODAL]: (state) => {
    state.modal = Object.assign(state.modal, {
      show: false
    });
  },
  [types.SHOW_CONFIRM]: (state) => {
    state.confirm = Object.assign({}, {
      show: true
    });
  },
  [types.HIDE_CONFIRM]: (state) => {
    state.confirm = Object.assign({}, {
      show: false
    });
  },
  [types.UPDATE_USER]: (state, data) => {
    state.userInfo = Object.assign({}, data);
  },
  [types.UPDATE_USER_STATUS]: (state, status) => {
    state.userStatus = status;
  },
  [types.UPDATE_STYLE]: (state) => {
    state.updateStyle = true;
  },
  [types.SHOW_LOADING]: (state, status) => {
    state.loading = status;
  },
  [types.SHOW_GUIDE]: (state, status) => {
    state.showGuide = status;
  },
  [types.GO_TO_LOGIN]: (state, status) => {
    state.goToLogin = status;
  }
}
